import { enumPortSortOption } from '@rematter/frontend-lib-api-client';

import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectablePort = QueryHookResult<typeof usePortsQuery>[number];

export const usePortsQuery = createQueryHook(
  'shared.selectPort',
  (params: {
    ids?: string[];
    searchTerm?: string;
    countryCode?: string;
    limit?: number;
    offset?: number;
  }) => ({
    ports: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          countryCode: params.countryCode,
        },
        pagination: {
          limit: 20,
          offset: 0,
        },
        sorting: [enumPortSortOption.NameAsc],
      },
      page: {
        offset: true,
        limit: true,
        total: true,
      },
      entries: {
        id: true,
        unLocode: true,
        name: true,
        countryCode: true,
        locationCode: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.ports.entries.map((entry) => ({
        id: entry.id,
        unLocode: entry.unLocode,
        name: entry.name,
        countryCode: entry.countryCode,
        locationCode: entry.locationCode,
      })) ?? [],
  },
);

export const SelectPort = createEntityComboBox.remotelySearched(
  'SelectPort',
  usePortsQuery,
  {
    formatLabel: (entity) => `${entity.name}・${entity.unLocode}`,
    formatSubLabel: (entity) => `${entity.countryCode}・${entity.locationCode}`,
  },
);
